var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFax = function SvgFax(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.00003V6.00003C5 5.4696 5.21071 4.9609 5.58579 4.58582C5.96086 4.21075 6.46957 4.00003 7 4.00003H17C17.5304 4.00003 18.0391 4.21075 18.4142 4.58582C18.7893 4.9609 19 5.4696 19 6.00003V9.00003M5 9.00003V15C5 15.5305 5.21071 16.0392 5.58579 16.4142C5.96086 16.7893 6.46957 17 7 17H17C17.5304 17 18.0391 16.7893 18.4142 16.4142C18.7893 16.0392 19 15.5305 19 15V9.00003M5 9.00003H19M7 17V19.0001C7 19.5305 7.21071 20.0392 7.58579 20.4142C7.96086 20.7893 8.46957 21.0001 9 21.0001H15C15.5304 21.0001 16.0391 20.7893 16.4142 20.4142C16.7893 20.0392 17 19.5305 17 19.0001V17M12 11H12.01M16 11H14",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFax;